module.exports = __webpack_public_path__ + "img/noData_logo.8d6bd2d3.png";